import { Check, MapPin } from '@phosphor-icons/react'
import { DateTime } from 'luxon'
import GoogleCalendarLogo from 'Assets/images/google-calendar.svg'

const CalendarEventItem = ({ event, color, onIncludeEvent, onExcludeEvent }) => {
  const start = DateTime.fromISO(event.start_at).setZone('local')
  const end = DateTime.fromISO(event.end_at).setZone('local')

  return (
    <div
      className="py-3 px-3 timeTrackerItem calendarEventItem"
      style={color ? { borderLeftColor: color } : undefined}>
      <div className="timeTrackerItem_ticket settings_fullname">
        <p className="m-0">
          <img className="me-1" src={GoogleCalendarLogo} alt="Google Calendar" width={16} height={16} />
          <span className="text-white fs-7">{event.title}</span>
        </p>

        <p className="m-0 fs-8">
          {event.is_all_day ? 'All day' : `${start.toFormat('h:mm a')} - ${end.toFormat('h:mm a')}`}
        </p>

        {event.location && (
          <p className="m-0 fs-8">
            <MapPin className="me-1" size={14} />
            {event.location}
          </p>
        )}
      </div>
      <div className="timeTrackerItem_actions">
        {event.time_entry_id
          ? (
          <button
            key="included"
            className="btn btn-ghost btn-sm calendarEventItem_actionBtn calendarEventItem_actionBtn--included"
            onClick={() => onExcludeEvent({ eventId: event.id })}>
            <span className="calendarEventItem_actionBtn_label">
              <Check className="me-1" size={14} weight="bold" />
              Included
            </span>
          </button>
            )
          : (
          <button
            key="include"
            className="btn btn-ghost btn-sm calendarEventItem_actionBtn calendarEventItem_actionBtn--include"
            onClick={() => onIncludeEvent({ eventId: event.id })}>
            <span className="calendarEventItem_actionBtn_label">Include</span>
          </button>
            )}
      </div>
    </div>
  )
}

export default CalendarEventItem
